import { tv } from 'tailwind-variants'

export const replyMessageCardVariants = tv({
  slots: {
    container: 'w-full flex flex-row space-x-mili justify-between items-center cursor-pointer',
    image: 'w-[100px] h-[50px] rounded-mili object-cover',
    close: 'ml-mili'
  },
  variants: {
    source: {
      CLIENT: {
        close: 'text-secondary-dark hover:text-secondary-xlight'
      },
      PRODUCT: {
        close: 'text-secondary-xlight hover:text-secondary-dark'
      }
    }
  }
})
